module.exports = __webpack_public_path__ + "img/登记材料准备@2x.3916abab.png";